import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import style from "./HorizontalCard.module.scss";
import SquareWrapper from "layouts/wrapper/SquareWrapper";
import SkeletonImage from "components/skeleton/SkeletonImage";
import clsx from "classnames";
import VerticalFlex from "layouts/flex/VerticalFlex";
import PaddingWrapper from "layouts/wrapper/PaddingWrapper";
import Center from "layouts/wrapper/Center";
import SkeletonText from "components/skeleton/SkeletonText";
import Inline from "layouts/container/Inline";
import P from "components/P";
import { addCommas } from "shared/utils/Utils";
import CustomIcon from "components/icons/CustomIcon";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "providers/AuthProvider";
import EventSticker from "./sticker/EventSticker";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import cartImg from "resources/img/category/cartIcon.png";
import Dummy from "components/Dummy";
import { renderPrice, getCustomPriceDisplay } from "shared/utils/Utils";


function HorizontalCard(props) {
    const {
        data,
        skeleton,
        onProductClick,
        addCartButtonClick,
        interests,
        onWishToggle
    } = props;
    const { userName } = useContext(AuthContext);
    const { isMobile } = useContext(BrowserDetectContext);
    const [isMounted, setMounted] = useState(false);
    const [isData, setData] = useState();

    const isWished = interests?.some(interest => interest.product_id === data?.id) || false;

    const handleWishClick = (e) => {
        e.stopPropagation();
        if (!userName) return;
        if (typeof onWishToggle === 'function' && data) {
            onWishToggle(data.id, isWished);
        } else {

        }
    };
    const displayPrice = renderPrice(data, userName);

    const HeartIcon = () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            className={clsx(style.heartIcon, { [style.wished]: isWished })}
        >
            {isWished ? (
                // Filled heart path
                <path d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z" />
            ) : (
                // Outline heart path
                <path d="M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8l0-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5l0 3.3c0 41.9-17.4 81.9-48.1 110.4L288.7 465.9l-2.5 2.3c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM239.1 145c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1s0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5l0 3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7 431.2 268c20.9-19.4 32.8-46.7 32.8-75.2l0-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7z" />
            )}
        </svg>
    );

    useEffect(() => {
        if (data) {
            setMounted(true);
        }
    }, [data])
    useEffect(() => {
        if (isMounted) {
            setData(data);
        }
    }, [isMounted])


    return (
        <FlexChild>
            {
                isMobile
                    ?
                    <div onClick={onProductClick}>
                        <VerticalFlex gap={10}>
                            <FlexChild>
                                <HorizontalFlex gap={10} padding={"10px"}>
                                    <FlexChild width={"max-content"}>
                                        {
                                            skeleton
                                                ?
                                                <div className={style.thumbnail} style={{ backgroundColor: "#ebebeb" }}>
                                                    <SquareWrapper>
                                                        {
                                                            skeleton ? <SkeletonImage width={100} />
                                                                : <img className={clsx(style.image, style.horizontalMobile)} src={data && data.thumbnail} alt={""} />
                                                        }
                                                    </SquareWrapper>
                                                </div>
                                                :
                                                <div className={style.horizontalThumbnail}>
                                                    {
                                                        props.rank &&
                                                        <div className={style.indexCircle}>{props.rank}</div>
                                                    }
                                                    <img className={clsx(style.image, style.horizontalMobile)} src={data && data.thumbnail} alt={""} />
                                                </div>
                                        }
                                    </FlexChild >
                                    <FlexChild backgroundColor={"white"} width={"45%"}>
                                        <VerticalFlex flexStart>

                                            <FlexChild>
                                                <PaddingWrapper padding={"15px 0 0 0"}>
                                                    {
                                                        skeleton ?
                                                            <Center width={"100%"} textAlign={"left"}>
                                                                <SkeletonText width={50} size={16} />
                                                                <SkeletonText width={50} size={16} />
                                                                <SkeletonText width={50} size={16} />
                                                                <Inline>
                                                                    <SkeletonText width={50} size={10} />
                                                                    <SkeletonText width={50} size={10} />
                                                                    <SkeletonText width={50} size={10} />
                                                                </Inline>
                                                                <SkeletonText width={50} size={10} />
                                                                <SkeletonText width={50} size={10} />
                                                            </Center>
                                                            :
                                                            <P cursor textHover ellipsis size={14} weight={"700"} whiteSpace={'nowrap'} overFlow={'hidden'} textOverflow={'ellipsis'}>{data && data?.title}</P>
                                                    }
                                                </PaddingWrapper>
                                            </FlexChild>
                                            <FlexChild justifyContent={"flex-start"}>
                                                <P
                                                    width={isMobile ? "150px" : "100%"}
                                                    textHover
                                                    cursor
                                                    onClick={onProductClick}
                                                    textAlign={"left"}
                                                    size={isMobile ? 16 : 20}
                                                    weight={"bold"}
                                                    color={"rgba(89, 87, 87, 1)"}
                                                    textDecoration={data.currentPrice && "line-through"}
                                                >
                                                    {Array.isArray(displayPrice) ? (
                                                        displayPrice.map((line, index) => (
                                                            <div key={index}>{line}</div>
                                                        ))
                                                    ) : (
                                                        displayPrice
                                                    )}
                                                </P>
                                            </FlexChild>
                                            <FlexChild>

                                                <Center width={"100%"}>

                                                    {data && data.event || data && data.discount_price ? (
                                                        <EventSticker isEvent={data.event} discount={data.discount_price} price={data.price} />
                                                    ) : (
                                                        <P
                                                            height={"20px"}
                                                            ellipsis
                                                            size={9}
                                                            weight={"900"}
                                                            color={"red"}
                                                        ></P>
                                                    )}
                                                </Center>
                                            </FlexChild>

                                        </VerticalFlex>
                                    </FlexChild>
                                    <FlexChild>
                                        <VerticalFlex padding={"0 10px"} justifyContent={"flex-end"} gap={10}>
                                            <FlexChild width={"max-content"}>
                                                <div onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleWishClick(e);
                                                }} className={style.mobileHeartBtn}>
                                                    <HeartIcon />
                                                </div>
                                            </FlexChild>
                                            <FlexChild width={"max-content"}>
                                                <div onClick={addCartButtonClick} className={style.mobileCartBtn}>
                                                    {/* <CustomIcon name={"shoppingBag"} width={18} color={"#282828"} /> */}
                                                    <img src={cartImg} />
                                                </div>
                                            </FlexChild>
                                        </VerticalFlex>
                                    </FlexChild>

                                </HorizontalFlex >
                            </FlexChild>
                            <FlexChild>
                                <div style={{ width: "100%", height: "1px", backgroundColor: "#aaa", opacity: 0.5 }} />
                            </FlexChild>
                        </VerticalFlex>



                    </div>

                    :
                    <HorizontalFlex gap={40}>
                        <FlexChild width={"max-content"}>
                            {
                                skeleton
                                    ?
                                    <div className={style.thumbnail} style={{ backgroundColor: "#ebebeb" }}>
                                        <SquareWrapper>
                                            {
                                                skeleton ? <SkeletonImage width={100} />
                                                    : <img className={clsx(style.image, style.horizontal)} src={data.thumbnail} alt={""} />
                                            }
                                        </SquareWrapper>
                                    </div>
                                    :
                                    <div className={style.horizontalThumbnail}>
                                        {/* <GiftSticker /> */}
                                        {
                                            props.rank &&
                                            <div className={style.indexCircle}>{props.rank}</div>
                                        }
                                        <img onClick={onProductClick} className={clsx(style.image, style.horizontal)} src={data && data.thumbnail} alt={""} />
                                        {/* <div className={style.horizontalButtonWrap}>
                                
                                {data && data.prices && data.prices.length > 0 ? null :
                                    <div onClick={wishButtonClick} className={clsx(style.button, style.wishButton)}>
                                        <button className={clsx(style.heart, { [style.active]: wish })}>
                                            <div className={style.heartFlip}></div>
                                        </button>
                                    </div>
                                }
                            </div> */}
                                    </div>
                            }
                        </FlexChild >
                        <FlexChild backgroundColor={"white"} width={"30%"}>
                            <VerticalFlex>

                                <FlexChild>
                                    <PaddingWrapper padding={"15px 0 0 0"}>
                                        {
                                            skeleton ?
                                                <Center width={"100%"} textAlign={"left"}>
                                                    <SkeletonText width={50} size={16} />
                                                    <SkeletonText width={50} size={16} />
                                                    <SkeletonText width={50} size={16} />
                                                    <Inline>
                                                        <SkeletonText width={50} size={10} />
                                                        <SkeletonText width={50} size={10} />
                                                        <SkeletonText width={50} size={10} />
                                                    </Inline>
                                                    <SkeletonText width={50} size={10} />
                                                    <SkeletonText width={50} size={10} />
                                                </Center>
                                                :
                                                <P textHover cursor onClick={onProductClick} ellipsis size={20} weight={"700"} whiteSpace={'nowrap'} overFlow={'hidden'} textOverflow={'ellipsis'}>{data && data.title}</P>
                                        }
                                    </PaddingWrapper>
                                </FlexChild>
                                <FlexChild alignItems={"flex-start"}>
                                    <Inline>
                                        {
                                            data && data.variants && data.variants.map((row, index) => (
                                                <P size={16}>{row.title}{" "}{data.variants.length === index + 1 ? null : " | "}</P>
                                            ))
                                        }
                                    </Inline>
                                    <Center width={"100%"} maxWidth={200} textAlign={"left"}>

                                        {
                                            isData ?
                                                data.event || data.discount_price ? (
                                                    <EventSticker isEvent={data && data.event} discount={data && data.discount_price} price={data && data.price} />
                                                ) : (
                                                    <P
                                                        height={"20px"}
                                                        ellipsis
                                                        size={12}
                                                        weight={"900"}
                                                        color={"red"}
                                                    ></P>
                                                )
                                                :
                                                null
                                        }
                                    </Center>
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>
                        <FlexChild>
                            <HorizontalFlex padding={"0 10px"}>
                                <FlexChild justifyContent={"center"} >
                                    <P
                                        width={isMobile ? "150px" : "100%"}
                                        textHover
                                        cursor
                                        onClick={onProductClick}
                                        textAlign={"right"}
                                        size={isMobile ? 16 : 20}
                                        weight={"bold"}
                                        color={"rgba(89, 87, 87, 1)"}
                                        textDecoration={data && data.currentPrice && "line-through"}
                                    >
                                        {Array.isArray(displayPrice) ? (
                                            displayPrice.map((line, index) => (
                                                <div key={index}>{line}</div>
                                            ))
                                        ) : (
                                            displayPrice
                                        )}
                                    </P>
                                </FlexChild>
                                <FlexChild justifyContent={"flex-end"} width={"46%"}>
                                    <VerticalFlex gap={10}>
                                        <FlexChild>
                                            <div onClick={(e) => {
                                                e.stopPropagation();
                                                handleWishClick(e);
                                            }} className={style.wishBtn}>
                                                <HeartIcon />
                                            </div>
                                        </FlexChild>
                                        <FlexChild>
                                            <div onClick={addCartButtonClick} className={style.cartBtn}>
                                                <P size={18} weight={500}>장바구니</P>
                                            </div>
                                        </FlexChild>
                                    </VerticalFlex>
                                </FlexChild>
                            </HorizontalFlex>
                        </FlexChild>
                    </HorizontalFlex >

            }
        </FlexChild>
    );
}

export default HorizontalCard;